// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rs-picker-menu {
  z-index: 100000;
}
.settingslist-submenu {
  padding-left: 16px;
  width: 100%;
  height: 100%;
  display: flex;
  user-select: none;
  justify-content: space-between;
}
.settingslist-submenu .settingslist-submenu-icon-left {
  display: flex;
  align-items: center;
  justify-content: center;
}
.settingslist-submenu .settingslist-submenu-icon-left > i {
  width: 30px;
  height: unset;
}
.settingslist-submenu .settingslist-submenu-icon-right {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
}
.settingslist-error {
  color: #f44336;
  margin-top: 4px;
  font-size: 12px;
}
.settingslist-input {
  -webkit-box-align: center;
  align-items: center;
  background-color: #ffffff;
  cursor: default;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  justify-content: space-between;
  position: relative;
  box-sizing: border-box;
  margin-top: 2px;
  width: 100%;
  height: 32px;
  min-height: 32px;
  border-color: #cccccc;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  overflow: auto;
  outline: 0px !important;
  padding-left: 6px;
}
.settingslist-input:focus {
  box-shadow: #2684ff 0px 0px 1px 1px;
  border-color: #2684ff;
}
.settingslist-items-tr-even {
  border-bottom: 1px solid #e0e0e0;
  background-color: rgba(127, 221, 233, 0.4);
  z-index: 10000;
  vertical-align: middle;
}
.settingslist-items-tr-even td {
  text-align: center;
  padding: 8px;
  border-left: 1px solid #e0e0e0;
  overflow: hidden;
}
.settingslist-items-tr-even .draggable-item {
  cursor: move;
  margin: 4;
}
.settingslist-items-tr-odd {
  border-bottom: 1px solid #e0e0e0;
  z-index: 10000;
  vertical-align: middle;
}
.settingslist-items-tr-odd td {
  text-align: center;
  padding: 8px;
  border-left: 1px solid #e0e0e0;
  overflow: hidden;
}
.settingslist-items-tr-odd .draggable-item {
  cursor: move;
  margin: 4;
}
.settingslist-items-tr-header {
  border-bottom: 1px solid #e0e0e0;
  z-index: 1000;
  vertical-align: middle;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 30px, rgba(0, 0, 0, 0.23) 0px 6px 10px;
}
.settingslist-items-tr-header td {
  text-align: center;
  padding: 8px;
  border-left: 1px solid #e0e0e0;
  overflow: hidden;
}
.settings-list.list-lite {
  display: grid;
  grid-auto-rows: minmax(30px, auto);
  grid-auto-flow: row;
  grid-gap: 5px;
  justify-content: stretch;
  justify-items: stretch;
  align-items: stretch;
  align-content: stretch;
  padding: 4px;
}
.settings-list.list-lite > div {
  height: 100%;
}
.settings-list.list-lite .attachments > label:hover,
.settings-list.list-lite .attachments > label.cannot-upload,
.settings-list.list-lite .attachments .attachment-overlay span:hover {
  opacity: 0.7;
}
.settings-list.list-lite .attachments .attachment-box .attachment-overlay {
  opacity: 0;
}
.settings-list.list-lite .attachments .attachment-box:hover .attachment-overlay {
  opacity: 1;
}
.settings-list.list-lite .attachments .attachment-box:hover .attachment-content {
  opacity: 0.3;
}
.settings-list.list-lite .rs-slider-handle::before {
  display: none;
}
.settings-list.list-lite .rs-slider[role=presentation] {
  width: 100%;
}
.settings-list.list-lite .slider-handle {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 6px solid #3498ff;
  background-color: #fff;
  margin-left: -6px;
  cursor: pointer;
  transition: box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out, transform 0.3s ease-in-out;
}
.settings-list .rs-picker-daterange.no-border > .rs-picker-toggle {
  border-radius: 0;
}
.settings-list button > svg {
  color: inherit !important;
}
.rs-picker-menu.fade.in.placement-bottom-end.rs-picker-daterange-menu.mobile .rs-picker-daterange-panel.rs-picker-daterange-panel-show-one-calendar .rs-picker-toolbar {
  padding: 0 !important;
  margin: 5px !important;
}
.rs-picker-menu.fade.in.placement-bottom-end.rs-picker-daterange-menu.mobile .rs-picker-daterange-panel.rs-picker-daterange-panel-show-one-calendar .rs-calendar {
  min-height: unset;
  height: unset;
  padding-bottom: 0;
}
.rs-picker-menu.fade.in.placement-bottom-end.rs-picker-daterange-menu.mobile .rs-picker-daterange-panel.rs-picker-daterange-panel-show-one-calendar .rs-calendar-view {
  padding: unset;
}
.rs-list#list-of-items-list {
  box-shadow: unset;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
